module.exports = __webpack_public_path__ + "img/linetwo.bfe0931f.svg";